import { txTypeText } from '../constant'

export const getTxTypeText = (type: string) => {
	if (txTypeText.hasOwnProperty(type)) {
		return txTypeText[type]
	}
	return type.toUpperCase()
}
